export type Feature =
  | 'dark-theme'
  | 'ads-filters'
  | 'ad-strength'
  | 'unspent-budget-cap'
  | 'team-dashboard-filters'
  | 'spend-unspent-budget-after-end-date'
  | 'ad-pool-bulk-actions'
  | 'google-maps-region-styling-test'
  | 'andorra-opt-out'
  | 'show-keywords-match-type'
  | 'is-staff-ui'
  | 'v2-app-theme'
  | 'video-upload-details'
  | 'video-manager';

export type FeatureMap = Record<Feature, boolean>;

// Order "matters"
export const FEATURE_FLAGS: FeatureMap = {
  // BETA
  'ads-filters': false,
  'unspent-budget-cap': false,
  'andorra-opt-out': false,
  'show-keywords-match-type': false,
  'is-staff-ui': true, // This is always true for staff users
  'v2-app-theme': false,
  // ALPHA
  'dark-theme': false,
  'ad-strength': false,
  'team-dashboard-filters': false,
  'spend-unspent-budget-after-end-date': false,
  'ad-pool-bulk-actions': false,
  'google-maps-region-styling-test': false,
  'video-upload-details': false,
  'video-manager': false,
};

// Features that are available to developers
const ALPHA_FEATURES = new Set<Feature>([
  'dark-theme',
  'ad-strength',
  'team-dashboard-filters',
  'spend-unspent-budget-after-end-date',
  'ad-pool-bulk-actions',
  'google-maps-region-styling-test',
  'video-upload-details',
  'video-manager',
]);

export function isAlphaFeature(feature: Feature) {
  return ALPHA_FEATURES.has(feature);
}

// Features that are available to staff users
const BETA_FEATURES = new Set<Feature>([
  'ads-filters',
  'unspent-budget-cap',
  'andorra-opt-out',
  'show-keywords-match-type',
  'is-staff-ui',
  'v2-app-theme',
]);

export function isBetaFeature(feature: Feature) {
  return BETA_FEATURES.has(feature);
}

const PUBLIC_BETA_FEATURES = new Set<Feature>([]);

export function isPublicBetaFeature(feature: Feature) {
  return PUBLIC_BETA_FEATURES.has(feature);
}
